import { rem } from 'polished'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { bezierCurve } from 'styles/tools/constants'
import zIndex from 'styles/tools/z-index'

const SearchMapOfferContainer = styled.div`
  position: absolute;
  display: flex;
  bottom: 0;
  inset-inline: 0;
  width: 100%;
  z-index: ${zIndex.min};
  pointer-events: none;
  transform: translateY(100%);
  transition: transform .3s ${bezierCurve};
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};

  &.show {
    pointer-events: auto;
    transform: translateY(0);
  }

  &.redesign {
    > * { width: 100%; min-width: 0; }
    .map-card { width: 100%; max-height: none; overflow: visible; }
    &:not(.show) { visibility: hidden; }
    bottom: max(${rem(8)}, env(safe-area-inset-bottom));
    inset-inline: ${rem(8)};
    width: auto;
    max-height: calc(100% - ${rem(172)});
    background: transparent;
    overflow-y: auto;
    border-radius: ${rem(20)};
    overscroll-behavior: contain;
  }

  ${mediaQueryUp.tablet} {
    justify-content: center;
  }
`

export default SearchMapOfferContainer
